var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("path",props);
}

ArrowDownInline.defaultProps = {"d":"M19,15l-1.41-1.41L13,18.17V2H11v16.17l-4.59-4.59L5,15l7,7L19,15z"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
